<template>
  <div class="mt-8">
    <Banner :key="uuid" />
    <UnlockParksBanner
      v-if="showUnlockBanner"
      :text="unlockBannerText"
    />
    <ModalRememberClose />

    <ModalGlobal id="modalUnlockPark" v-if="modalUnlockPark" @close-modal="modalUnlockPark = false">
      <template #dialogHeadImg>
        <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          :src="GetS3AssetUrl('suf/home/photo-pass-logo.png')" alt="logo photo" />
      </template>

      <!-- <template #dialogHeading> 3/3 Albumes seleccionados </template> -->

      <template #dialogDescription>
        <p class="font-bold mb-3 text-center">
          {{ unlockPark.used }}/{{
            unlockPark.limit
          }}
          {{ $t("gallery.album_select") }}
        </p>
        <p class="text-sm mb-3 text-center">
          <!-- Use the configured copy for packages with three or more park unlocks. -->
          <span v-html="(unlockPark.limit >= 3 && albumConfirmDynamicText) ? albumConfirmDynamicText : $t('gallery.album_confirm')"></span>
        </p>
        <p class="font-bold mb-4 text-center">
          {{ $t("gallery.park_unlock") }}
        </p>
      </template>

      <a @click.prevent="AddVisitPark()"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto">
        {{ $t("gallery.album_unlock") }}
      </a>

      <button @click="modalUnlockPark = false" type="button"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto">
        {{ $t("gallery.continue") }}
      </button>
    </ModalGlobal>

    <ModalGlobal id="modalDeleteTags" v-if="modalDeleteTags" @close-modal="modalDeleteTags = false">
      <template #dialogHeadImg>
        <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          :src="GetS3AssetUrl('suf/home/photo-pass-logo.png')" alt="logo photo" />
      </template>

      <!-- <template #dialogHeading> 3/3 Albumes seleccionados </template> -->

      <template #dialogDescription>
        <p class="font-bold mb-3 text-center">
          {{ $tc("Forms.tags", deleteTags.tags.length) }}({{
            deleteTags.tags.length
          }})
        </p>

        <div class="isoCurrencies flex flex-wrap -mb-1">
          <div
            class="btnDeleteTags flex justify-center rounded py-3 px-4 mb-1 border-yellow-photo border bg-white font-semibold"
            v-for="(item, idx) in deleteTags.tags" :key="idx">
            {{ item }}
            <span @click.prevent="RemoveTagFromAlbum(idx)" class="deleteTags material-icons cursor-pointer"
              v-if="deleteTags.tags.length > 1">
              highlight_off
            </span>
          </div>
        </div>
      </template>

      <!-- <a
  @click.prevent="AddVisitPark()"
  class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto"
  >
  {{ $t("gallery.album_unlock") }}
  </a> -->

      <button @click="modalDeleteTags = false" type="button"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 mt-6 border-yellow-photo border bg-yellow-photo shadow-lg cursor-pointer font-semibold mx-auto">
        {{ $t("gallery.continue") }}
      </button>
    </ModalGlobal>

    <!-- <a @click.prevent="$store.dispatch('cleanAfterShopping')">Clear ShoppingCart</a> -->

    <section :key="$store.getters.updateAlbumComponent"
      class="flex flex-col-reverse md:flex-row container mx-auto menu">
      <div class="flex flex-col w-full px-4 pt-8">
        <div class="w-full md:w-3/4 flex justify-right items-end pb-4">
          <button class="w-3/4 py-2 px-4 bg-white border-black" :class="[
            $store.state.typeCodeTab == 0
              ? 'active border-x border-t rounded-t-lg'
              : 'border-b',
            !$store.state.tabDownloadCode &&
            'cursor-no-drop disabled hidden',
          ]" @click.prevent="
                          $store.state.tabDownloadCode &&
                          $store.dispatch('setTypeCodeTab', 0)
                          " type="button">
            <span class="albumes material-icons">
              qr_code_scanner
            </span>
            <span class="font-semibold">{{
              $tc("Forms.download_code", 2)
            }}</span>
          </button>
          <button class="w-3/4 py-2 px-4 bg-white border-black" :class="[
            $store.state.typeCodeTab == 1
              ? 'active border-x border-t rounded-t-lg'
              : 'border-b',
            !$store.state.tabTags &&
            'cursor-no-drop disabled hidden',
          ]" @click.prevent="
                          $store.state.tabTags &&
                          $store.dispatch('setTypeCodeTab', 1)
                          " type="button">
            <span class="albumes material-icons"> bookmark </span>
            <span class="font-semibold">{{
              $tc("Forms.tags", 2)
            }}</span>
          </button>
          <button class="w-3/4 py-2 px-4 bg-white border-black" :class="[
            $store.state.typeCodeTab == 2
              ? 'active border-x border-t rounded-t-lg'
              : 'border-b',
            !$store.state.tabReservations &&
            'cursor-no-drop disabled hidden',
          ]" @click.prevent="
                          $store.state.tabReservations &&
                          $store.dispatch('setTypeCodeTab', 2)
                          " type="button">
            <span class="albumes material-icons"> apartment </span>
            <span class="font-semibold">{{
              $tc("Forms.reservations", 2)
            }}</span>
          </button>

          <button class="w-3/4 py-2 px-4 bg-white border-black" :class="[
            $store.state.typeCodeTab == 5
              ? 'active border-x border-t rounded-t-lg'
              : 'border-b',
            !$store.state.tabFreeGallery &&
            'cursor-no-drop disabled hidden',
          ]" @click.prevent="
                          $store.state.tabFreeGallery &&
                          $store.dispatch('setTypeCodeTab', 5)
                          " type="button">
            <span class="albumes material-icons"> redeem </span>
            <span class="font-semibold">
              {{ $t("gallery.free_albums") }}
            </span>
          </button>
        </div>

        <!-- <button
  class="
  shadownBottom
  md:flex
  w-1/3
  flex-row
  items-center
  justify-center
  relative
  cursor-pointer
  bg-yellow-photo
  rounded-full
  px-4
  py-4
  "
  @click.prevent="
  $store.dispatch('clearShoppingCart')
  "
  type="button"
  >
  Eliminar Albumes
  </button> -->

        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 0">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Codigos de descarga -->
            <section class="flex flex-col md:flex-row container mx-auto flex-wrap" :key="index" v-if="item.Type === 0">
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div class="absolute flex flex-auto bg-white top-8 right-8 pl-8">
                  <span class="font-bold mr-1">{{ $t("gallery.code") }}
                  </span>
                  <span class="mr-1">{{ item.code }}</span>
                  |
                  <span class="ml-1">
                    <button @click.prevent="
                      UpdateAlbum(item.code)
                      " type="button"
                      class="updateAlbum shadownBottom flex w-full justify-center items-center p-2 pl-4 pr-4 bg-yellow-photo rounded text-sm cursor-pointer">
                      <span class="material-icons">
                        autorenew
                      </span>
                    </button>
                  </span>
                </div>
              </div>

              <div class="w-full md:w-1/3 px-8 mb-8" v-for="(park, index2) in item.park" :key="index2">
                <router-link class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  @click.native.capture="PreventExpiredAlbumNavigation($event, item, park)"
                  :aria-disabled="isAlbumCommerciallyExpired(item, park) ? 'true' : 'false'"
                  :to="{
                  name: 'gallery',
                  query: {
                    uuid: item.uuid,
                    ParkId: park.Park.Id,
                    type: item.Type,
                    page: 1,
                    albumType: park.AlbumType,
                    albumId: park.AlbumKey.Id,
                  },
                }">
                  <!-- Presenta albumes por busqueda con codigo de descarga -->
                  <div class="coverAlbumes relative pointer-events-none">
                    <img :src="park.Thumb" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " alt="albumes" class="w-full opacity-70" />

                    <img :src="park.Thumb" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " alt="albumes" class="w-full absolute top-2 left-2" />
                    <div
                      v-if="shouldShowExpirationBadge(item, park)"
                      :class="albumExpirationBadgeClass(item, park)"
                    >
                      {{ calculateExpiredDays(item, park) }}
                    </div>
</div>
                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img :src="GetS3AssetUrl('suf/logos/albumes/hotel-' + park.Park.Id + '.png')" :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook" />
                      <img :src="GetS3AssetUrl('suf/logos/albumes/park-' + park.Park.Id + '.png')" :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain" v-else />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div>
                        <template v-if="park.AlbumType == 1">
                          <span class="albumes material-icons">
                            smart_display
                          </span>
                          <span>
                            {{
                              $tc(
                                "messages.videos",
                                park.TotalMedia
                              )
                            }}
                          </span>
                        </template>

                        <template v-else>
                          <span class="albumes material-icons">
                            crop_original
                          </span>
                          <span>
                            {{
                              $tc(
                                "messages.photos",
                                CalculateTotalMedia(
                                  park
                                )
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </router-link>

                <button
                  type="button"
                  class="album-expired-button flex w-full justify-center items-center p-2 rounded-full text-sm font-bold cursor-no-drop"
                  v-if="isAlbumCommerciallyExpired(item, park)"
                  disabled
                >
                  {{ $t("gallery.album_expired") }}
                </button>

                <template v-else-if="!park.Unlocked && item.order == 0">
                  <!-- {{ IsParkForSale(index) }} -->
                  <button type="button"
                    class="shadownBottom flex w-full justify-center items-center p-2 bg-blue-700 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      UnlockParks(index, park.Park.Id)
                      " v-if="!IsParkForSale(index)">
                    {{ $t("gallery.unlock") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      lock_open
                    </span>
                  </button>
                  <template v-if="IsParkForSale(index)">
                    <button
                      type="button"
                      class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                      v-if="
                        item.FreeHotels &&
                        park.Park.IsHotel &&
                        park.AlbumType === 0
                      "
                    >
                      {{ $t("gallery.free") }}
                    </button>

                    <button
                      type="button"
                      class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                      v-else-if="park.WasAutoAddedByPromotion || park.WasIncludedByPromotion"
                    >
                      {{ $t("gallery.AddedByPromotion") }}
                    </button>

                    <button
                      type="button"
                      class="shadownBottom flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                      @click="
                        $store.dispatch(
                          'removeShoppingCartByDownloadCode',
                          {
                            park,
                            idx: index,
                          }
                        )
                      "
                      v-else-if="park.IsAdded"
                    >
                      {{ $t("gallery.cart_quit") }}
                      &nbsp;&nbsp;
                      <span class="albumes addcart material-icons">
                        delete
                      </span>
                    </button>

                    <button
                      type="button"
                      class="shadownBottom flex w-full justify-center items-center p-2 bg-blue-700 text-white rounded-full text-sm font-bold cursor-pointer"
                      @click.prevent="
                        $store.dispatch(
                          'addCartByDownloadCode',
                          {
                            idx: index,
                            park,
                          }
                        )
                      "
                      v-else-if="park.CanBeIncludedByPromotion"
                    >
                      {{ $t("gallery.include_album") }}
                      &nbsp;&nbsp;
                      <span class="albumes addcart material-icons">
                        add_circle
                      </span>
                    </button>

                    <button
                      type="button"
                      class="shadownBottom flex w-full justify-center items-center p-2 bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                      @click.prevent="
                        $store.dispatch(
                          'addCartByDownloadCode',
                          {
                            idx: index,
                            park,
                          }
                        )
                      "
                      v-else
                    >
                      {{ $t("gallery.cart_add") }}
                      &nbsp;&nbsp;
                      <span class="albumes addcart material-icons">
                        local_grocery_store
                      </span>
                    </button>
                  </template>
                </template>

                <button type="button"
                  class="hidden flex w-full justify-center p-2 border border-newxcaret-blue bg-white text-newxcaret-blue rounded-full text-sm cursor-pointer">
                  {{ $t("gallery.album_download") }}
                </button>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 1">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Brazalete -->
            <section class="flex flex-col md:flex-row container mx-auto flex-wrap" v-if="item.Type === 1" :key="index">
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div class="absolute flex flex-auto bg-white top-8 right-8 pl-8">
                  <span class="font-bold mr-1">{{
                    $tc("Forms.tags", item.Tags.length)
                  }}
                  </span>
                  <!-- <span class="mr-1">{{ item.code }}</span> -->
                  |
                  <span class="ml-1">
                    <button @click.prevent="
                      DeleteTagsAlbum(item)
                      " type="button"
                      class="updateAlbum shadownBottom flex w-full justify-center items-center p-2 pl-4 pr-4 bg-yellow-photo rounded text-sm cursor-pointer">
                      <span class="material-icons">
                        visibility
                      </span>
                    </button>
                  </span>
                </div>
              </div>

              <div class="w-full md:w-1/3 px-8 mb-8" v-for="(park, index2) in item.park" :key="index2">
                <router-link class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  @click.native.capture="PreventExpiredAlbumNavigation($event, item, park)"
                  :aria-disabled="isAlbumCommerciallyExpired(item, park) ? 'true' : 'false'"
                  :to="{
                  name: 'gallery',
                  query: {
                    uuid: item.uuid,
                    ParkId: park.Park.Id,
                    type: item.Type,
                    page: 1,
                    albumType: park.AlbumType,
                    albumId: park.AlbumKey.Id,
                  },
                }">
                  <div class="coverAlbumes relative pointer-events-none">
                    <img :src="park.Thumb" :alt="park.Park.Name" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " class="w-full opacity-70" />

                    <img :src="park.Thumb" :alt="park.Park.Name" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " class="w-full absolute top-2 left-2" />
                    <div
                      v-if="shouldShowExpirationBadge(item, park)"
                      :class="albumExpirationBadgeClass(item, park)"
                    >
                      {{ calculateExpiredDays(item, park) }}
                    </div>
</div>

                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img :src="GetS3AssetUrl('suf/logos/albumes/hotel-' + park.Park.Id + '.png')" :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook" />
                      <img :src="GetS3AssetUrl('suf/logos/albumes/park-' + park.Park.Id + '.png')" :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain" v-else />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div>
                        <template v-if="park.AlbumType == 1">
                          <span class="albumes material-icons">
                            smart_display
                          </span>
                          <span>
                            {{
                              $tc(
                                "messages.videos",
                                park.TotalMedia
                              )
                            }}
                          </span>
                        </template>

                        <template v-else>
                          <span class="albumes material-icons">
                            crop_original
                          </span>
                          <span>
                            {{
                              $tc(
                                "messages.photos",
                                park.TotalMedia
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </router-link>

                <button
                  type="button"
                  class="album-expired-button flex w-full justify-center items-center p-2 rounded-full text-sm font-bold cursor-no-drop"
                  v-if="isAlbumCommerciallyExpired(item, park)"
                  disabled
                >
                  {{ $t("gallery.album_expired") }}
                </button>

                <template v-else-if="hasQuotingService(park)">
                  <button type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch(
                        'removeParkServiceIdFromShoppingCart',
                        {
                          park,
                          tag: item.code,
                        }
                      )
                      " v-if="park.IsAdded">
                    {{
                      $t("gallery.cart_quit")
                    }}
                    &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      delete
                    </span>
                  </button>

                  <button type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      $store.dispatch(
                        'addCartByServiceId',
                        {
                          park,
                          tag: item.code,
                          tags: item.Tags,
                          eventDetails: item.eventDetails,
                        }
                      )
                      " v-else-if="
                                          park.AlbumType == 0 &&
                                          park?.AlbumMode == 0
                                        ">
                    {{
                      $t("gallery.cart_add")
                    }}
                    &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      local_grocery_store
                    </span>
                  </button>
                </template>
                <template v-else>
                  <button type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch(
                        'removeAlbumFromShoppingCart',
                        {
                          album: park,
                          albumIndex: index,
                        }
                      )
                      " v-if="park.IsAdded">
                    {{
                      $t("gallery.cart_quit")
                    }}
                    &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      delete
                    </span>
                  </button>

                  <button type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      $store.dispatch(
                        'addCartByTag',
                        park
                      )
                      " v-else-if="
                                          park.AlbumType == 0 &&
                                          park?.AlbumMode == 0
                                        ">
                    {{
                      $t("gallery.cart_add")
                    }}
                    &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      local_grocery_store
                    </span>
                  </button>
                </template>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 2">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Room -->
            <section class="albumes flex flex-col md:flex-row container mx-auto flex-wrap" v-if="item.Type == 2"
              :key="index">
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div class="absolute flex flex-auto bg-white top-8 right-8 pl-8">
                  <span class="font-bold mr-1">{{ $t("gallery.reserv") }}
                  </span>
                  <span class="mr-1">#{{ item.BookId || item.code }}</span>
                  <!-- |
          <span class="ml-1">{{
              $tc("messages.albumes", item.albumes)
          }}</span> -->
                </div>
              </div>

              <div class="album w-full md:w-1/3 px-8 mb-8" v-for="(park, idx2) in item.park" :key="idx2">
                <router-link class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  @click.native.capture="PreventExpiredAlbumNavigation($event, item, park)"
                  :aria-disabled="isAlbumCommerciallyExpired(item, park) ? 'true' : 'false'"
                  :to="{
                  name: 'gallery',
                  query: {
                    uuid: item.uuid,
                    ParkId: park.Park.Id,
                    type: item.Type,
                    page: 1,
                    albumType: park.AlbumType,
                    albumId: park.AlbumKey.Id,
                  },
                }">
                  <!-- Presenta albumes por busqueda de reserva  -->
                  <div class="coverAlbumes relative pointer-events-none">
                    <img :src="park.Thumb" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " alt="albumes" class="w-full opacity-70" />

                    <img :src="park.Thumb" @error="
                      replaceImgByDefault(
                        $event,
                        park.Park.Id
                      )
                      " alt="albumes" class="w-full absolute top-2 left-2" />
                    <div
                      v-if="shouldShowExpirationBadge(item, park)"
                      :class="albumExpirationBadgeClass(item, park)"
                    >
                      {{ calculateExpiredDays(item, park) }}
                    </div>
</div>

                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img :src="GetS3AssetUrl('suf/logos/albumes/hotel-' + park.Park.Id + '.png')"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook" />
                      <img :src="GetS3AssetUrl('suf/logos/albumes/park-' + park.Park.Id + '.png')"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain" v-else />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div class="w-3/4 flex flex-col items-end">
                        <div>
                          <template v-if="
                            park.AlbumType == 1
                          ">
                            <span class="albumes material-icons">
                              smart_display
                            </span>
                            <span>
                              {{
                                $tc(
                                  "messages.videos",
                                  park.TotalMedia
                                )
                              }}
                            </span>
                          </template>

                          <template v-else>
                            <span class="albumes material-icons">
                              crop_original
                            </span>
                            <span>
                              {{
                                $tc(
                                  "messages.photos",
                                  park.TotalMedia
                                )
                              }}
                            </span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>

                <button
                  type="button"
                  class="album-expired-button flex w-full justify-center items-center p-2 rounded-full text-sm font-bold cursor-no-drop"
                  v-if="isAlbumCommerciallyExpired(item, park)"
                  disabled
                >
                  {{ $t("gallery.album_expired") }}
                </button>

                <template v-else>
                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                    v-if="
                      item.FreeHotels &&
                      park.Park.IsHotel &&
                      park.AlbumType === 0
                    "
                  >
                    {{ $t("gallery.free") }}
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                    v-else-if="park.WasAutoAddedByPromotion || park.WasIncludedByPromotion"
                  >
                    {{ $t("gallery.AddedByPromotion") }}
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch(
                        'removeParkServiceIdFromShoppingCart',
                        {
                          park,
                          tag: park.uuid || park.Park.Id,
                        }
                      )
                    "
                    v-else-if="park.IsAdded && hasQuotingService(park)"
                  >
                    {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      delete
                    </span>
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch(
                        'removeShoppingCartByRoom',
                        {
                          park,
                          idx: index,
                        }
                      )
                    "
                    v-else-if="park.IsAdded"
                  >
                    {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      delete
                    </span>
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-blue-700 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      $store.dispatch('addCartByRoom', {
                        park,
                        idx: index,
                      })
                    "
                    v-else-if="park.CanBeIncludedByPromotion"
                  >
                    {{ $t("gallery.include_album") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      add_circle
                    </span>
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      $store.dispatch('addCartByRoom', {
                        park,
                        idx: index,
                      })
                    "
                    v-else-if="park.AlbumType == 0"
                  >
                    {{ $t("gallery.cart_add") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      local_grocery_store
                    </span>
                  </button>
                </template>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 5">
          <!-- Free Gallery -->
          <section class="albumes flex flex-col md:flex-row container mx-auto flex-wrap">
            <div class="relative flex w-full mb-10 px-8 justify-center">
              <hr class="flex w-full mt-10 border-black border-b" />
              <div class="absolute flex flex-auto bg-white top-8 right-8 pl-8">
                <span class="font-bold mr-1">{{
                  $t("gallery.free_albums")
                }}</span>
                <!-- <span class="mr-1">#{{ item.code }}</span> -->
              </div>
            </div>

            <div class="album w-full md:w-1/3 px-8 mb-8" v-for="(park, idx) in freeAlbumsFiltered" :key="idx">
              <router-link class="flex flex-col cursor-pointer hover:scale-105 duration-300" :to="{
                name: 'gallery',
                query: {
                  ParkId: park.parkId,
                  type: 5,
                  page: 1,
                  albumType: 0,
                  albumId: park.parkId,
                  freeGallery: true,
                },
              }">
                <div class="coverAlbumes relative pointer-events-none">
                  <img @error="
                    replaceImgByDefault(
                      $event,
                      park.parkId
                    )
                    " :src="GetS3AssetUrl('suf/logos/albumes/covers/park-' + park.parkId + '.jpg')" alt="albumes" class="w-full opacity-70" />

                  <img @error="
                    replaceImgByDefault(
                      $event,
                      park.parkId
                    )
                    " :src="GetS3AssetUrl('suf/logos/albumes/covers/park-' + park.parkId + '.jpg')" alt="albumes" class="w-full absolute top-2 left-2" />
                </div>

                <div class="flex py-3 items-center pointer-events-none">
                  <div class="w-1/2 flex items-center">
                    <img :src="GetS3AssetUrl('suf/logos/albumes/hotel-' + park.parkId + '.png')"
                      class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                      v-if="park.IsBook" />
                    <img :src="GetS3AssetUrl('suf/logos/albumes/park-' + park.parkId + '.png')"
                      class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain" v-else />
                  </div>

                  <div class="w-1/2 flex flex-col items-end">
                    <div>
                      <span class="albumes material-icons">
                        crop_original
                      </span>
                      <span>
                        {{
                          $tc(
                            "messages.photos",
                            park.TotalMedia
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </section>
        </div>
        <div class="active tabs-content" v-if="!$store.state.albumes.length">
          <img class="no-data" :src="GetS3AssetUrl('suf/no-data.png')" alt="" />
        </div>
      </div>
    </section>

    <!-- <button v-on:click="show = !show">
  Mostrar/Ocultar
  </button>
  <transition name="fade">
  <p v-if="show">hola</p>
  </transition> -->

    <TranferProgressWidget />
  </div>
</template>

<script>
import albumExpirationHelper from "../helpers/albumExpirationHelper";
import promotionConfigHelper from "../helpers/promotionConfigHelper";
import AlbumesMix from "../components/mixins/Albumes";

import Banner from "../components/store/shoppingCartCounterComponent.vue";
import Footer from "../components/Footer.vue";
import ModalRememberClose from "../components/Modals/CloseSessionModal.vue";
import ShoppingCartCounter from "../components/store/shoppingCartCounterComponent.vue";
import Gallery from "./Gallery.vue";
import TranferProgressWidget from "../components/photo/DownloadedMultimediaComponent.vue";
import UnlockParksBanner from "../components/albums/UnlockParksBanner.vue";
import { GetS3AssetUrl } from "../helpers/s3AssetHelper";
import { GetApiErrorMessage } from "../helpers/apiErrorHelper";
import { HasQuotingService } from "../helpers/albumContractAdapter";

export default {
  mixins: [AlbumesMix],
  components: {
    Banner,
    Footer,
    ShoppingCartCounter,
    Gallery,
    TranferProgressWidget,
    ModalRememberClose,
    UnlockParksBanner,
  },
  data: () => ({
    components: {},
    uuid: 100,
    show: true,
    freeAlbums: [],
    freeAlbumsFiltered: [],
    albumConfirmDynamicText: "",
  }),
  computed: {
    shoppingCartAmount: {
        // getter
        get() {
            return Object.value(this.$store.state.albumes).lenght;
        },
        // setter
        set(newValue) {
            // Note: we are using destructuring assignment syntax here.
            // [this.firstName, this.lastName] = newValue.split(' ')
        },
    },

    /**
     * Gets the reservation photo albums that can be considered for the
     * unlock banner. Hotel albums and quotation-service albums are excluded
     * because they do not trigger the PhotoPark promotion.
     *
     * @returns {Array<Object>} Valid reservation park albums.
     */
    reservationValidAlbumsForBanner() {
        const reservationAlbums = this.$store.state.albumes.filter(
            (item) => item.Type == 2
        );

        const albums = reservationAlbums
            .map((item) => item.park || [])
            .flat();

        return albums.filter((park) => {
            return (
                park.AlbumType === 0 &&
                !park.Park?.IsHotel &&
                !this.hasQuotingService(park)
            );
        });
    },

    /**
     * Resolves the promotion configuration used by the banner. The cart
     * configuration is preferred because it already reflects the active quote;
     * loaded albums are used as fallback before any item is added to the cart.
     *
     * @returns {Object|null} Normalized promotion configuration.
     */
    promotionBannerConfig() {
        const shoppingCartItems = Object.values(
            this.$store.state.shoppingCart || {}
        );

        const cartPromotion = shoppingCartItems
            .map((item) =>
                promotionConfigHelper.GetPromotionConfigFromCartItem(item)
            )
            .find((promotion) =>
                promotionConfigHelper.HasPromotionConfig(promotion)
            );

        if (cartPromotion) {
            return cartPromotion;
        }

        return promotionConfigHelper.FindPromotionConfigInAlbums(
            this.$store.state.albumes || []
        );
    },

    albumPromotionBannerConfig() {
        return this.$store.state.AlbumPromotionConfig || {};
    },

    unlockBannerText() {
        return this.$t("gallery.unlock_banner", {
            required: Number(this.promotionBannerConfig.requiredPurchases || 3),
        });
    },

    showUnlockBanner() {
        const bannerConfig = this.albumPromotionBannerConfig;
        const showUnlockBanner =
            bannerConfig.ShowUnlockBanner === true ||
            bannerConfig.ShowUnlockBanner === "true" ||
            Number(bannerConfig.ShowUnlockBanner || 0) === 1;
        const maxAlbums = Number(bannerConfig.ShowUnlockBannerMaxAlbums || 0);
        const validAlbumsLength = this.reservationValidAlbumsForBanner.length;

        return (
            this.$store.state.typeCodeTab == 2 &&
            showUnlockBanner &&
            validAlbumsLength > 0 &&
            (!maxAlbums || validAlbumsLength <= maxAlbums)
        );
    },
  },
  methods: {
    /**
     * Checks whether an album uses an explicit quotation service.
     *
     * @param {Object} park Album experience.
     * @returns {boolean} True when the experience has quotation configuration.
     */
    hasQuotingService(park) {
      return HasQuotingService(park?.QuotingService);
    },
    /**
     * Builds an asset URL from the configured public S3 bucket.
     *
     * @param {string} path Public asset path.
     * @returns {string} Absolute public asset URL.
     */
    GetS3AssetUrl(path) {
      return GetS3AssetUrl(path);
    },
    /**
     * Prevents navigation when an album is commercially expired.
     *
     * @param {MouseEvent} event Native router-link click event.
     * @param {Object} item Album group data.
     * @param {Object} park Park album data.
     * @returns {void}
     */
    PreventExpiredAlbumNavigation(event, item, park) {
      if (!this.isAlbumCommerciallyExpired(item, park)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    /**
     * Replaces a broken album cover with the default park cover from the
     * configured public S3 bucket.
     *
     * @param {Event} e Image error event.
     * @param {number|string} parkId Park identifier used in the fallback file name.
     */
    replaceImgByDefault(e, parkId) {
      e.target.src = GetS3AssetUrl(`suf/logos/albumes/covers/park-${parkId}.jpg`);
    },
    calculateExpiredDays(item, park) {
      return albumExpirationHelper.FormatExpirationText({
        album: item,
        park,
        translate: this.$t.bind(this),
      });
    },
    shouldShowExpirationBadge(item, park) {
      if (this.isAlbumCommerciallyExpired(item, park)) {
        return false;
      }

      return albumExpirationHelper.ShouldShowExpirationBadge({
        album: item,
        park,
      });
    },
    albumExpirationBadgeClass(item, park) {
      return albumExpirationHelper.GetExpirationBadgeClass(
        albumExpirationHelper.GetExpirationDate({ album: item, park })
      );
    },
    isAlbumCommerciallyExpired(item, park) {
      return albumExpirationHelper.IsAlbumCommerciallyExpired({
        album: item,
        park,
      });
    },
    forceRerender() {
      this.uuid += 1;
    },
    imageToBlob(url) {
      return new Promise(function (resolve, reject) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.onerror = function () {
            reject("Network error.");
          };
          xhr.onload = function () {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject("Loading error:" + xhr.statusText);
            }
          };
          xhr.send();
        } catch (err) {
          reject(err.message);
        }
      });
    },
    blobToBase64() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    packageFilter(data, service) {
      return data.filter((park) => {
        if (park.isEvent) {
          return service.some((pkg) =>
            park.AvailablePackage.includes(pkg)
          );
        }
        return true;
      });
    },
    /**
     * Loads the free-albums configuration from the Vuex in-memory cache.
     *
     * @returns {Promise<Array<Object>>} Free-albums configuration entries.
     */
    async LoadFreeAlbumsConfiguration() {
        try {
            return await this.$store.dispatch("GetFreeAlbumsConfiguration");
        } catch (error) {
            this.$toast.open({
                message: GetApiErrorMessage(
                    error,
                    this.$t("messages.service_temporarily_unavailable"),
                    true
                ),
                type: "error",
            });

            return [];
        }
    },
    async getFilteredPackage() {
      let filteredFreeAlbums = this.packageFilter(
        this.freeAlbums,
        this.$store.getters.getPackages
      );
      this.freeAlbumsFiltered = filteredFreeAlbums.map((item) => {
        return {
          parkId: item.ParkId,
          TotalMedia: item.TotalPhotos,
          parkName: item.parkName,
        };
      });
    },
    /**
     * Loads the dynamic text for the album confirmation, if available and active. If not, it sets the text to an empty string.
     * The function retrieves the dynamic text based on a specific EventId and the current language setting, and updates the component's state accordingly.
     * If the dynamic text is not active or an error occurs during retrieval, the albumConfirmDynamicText is set to an empty string.
      * @returns {Promise<void>}
     */
    async loadDynamicAlbumConfirmText() {
      const params = { 
        EventId: "bfe41907-7f06-11f1-b4af-16fff806" 
      };
      let response = {};

      try {
        response = await this.$store.dispatch(
          "getOptionsDynamicText",
          {
            params,
            storeKey: params.EventId,
          }
        );

        const data = response;
      
        if (!data || typeof data !== "object" || !data.Active) {
          this.albumConfirmDynamicText = "";
          return;
        }

        const locale = (
          (this.$store.getters.getLanguage ||
            (this.$i18n && this.$i18n.locale) ||
            "es") + ""
        ).toLowerCase();
        const content = data.Sections.Albums.UnlockConfirmText || {};
        const translatedText = locale.startsWith("en")
          ? content.en
          : content.es;

        this.albumConfirmDynamicText =
          typeof translatedText === "string"
            ? translatedText.trim()
            : "";
      } catch (error) {
        this.albumConfirmDynamicText = "";
      }
    },
  },
  watch: {
    "$store.state.albumes"() {
      this.getFilteredPackage();
    },
  },
  async mounted() { },
  async created() {
    await this.loadDynamicAlbumConfirmText();
    await this.$store.dispatch("cleanEventDetails");
    await this.$store.dispatch("removeEventFromShoppingCart");

    this.freeAlbums = await this.LoadFreeAlbumsConfiguration();
    await this.getFilteredPackage();
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
